import _ from "underscore";
import {ClauseAtom, DocumentSection} from "common/types/document";

function getClauseDocumentOrder(
  clause: ClauseAtom,
  documentSections: DocumentSection[],
  useClauseOrder = false,
): string {
  const sectionId = clause.clause_section_id || clause.section_id;
  const section =
    (documentSections || []).find(s => s.id === sectionId) ||
    ({} as DocumentSection);
  const referenceParts0 =
    (
      clause?.clause_reference?.toString() ??
      clause?.reference?.toString() ??
      ""
    ).split(".")[0] || "";

  return [
    section.file_index?.toString(),
    section.order?.toString(),
    referenceParts0,
    useClauseOrder ? clause.clause_order : clause.id,
  ]
    .filter(
      (item): item is string | number => item !== undefined && item !== null,
    )
    .map(item => item.toString().padStart(4, "0"))
    .join("_");
}

function sortClausesByDocumentOrder<T extends ClauseAtom>(
  clauses: T[],
  documentSections: DocumentSection[],
  useClauseOrder = false,
): T[] {
  return _.sortBy(clauses, clause =>
    getClauseDocumentOrder(clause, documentSections, useClauseOrder),
  );
}

export {getClauseDocumentOrder};
export default sortClausesByDocumentOrder;
